// extracted by mini-css-extract-plugin
export default {"image":"CoverPicture_image__2vY3S"};